export default __webpack_public_path__ + "static/media/avaibleGoogle.7d108198.png";